import React from 'react';
import ThemeToggle from './ThemeToggle';
import '../../styles/horizonHome.css';
import '../../styles/horizonClient.css';

export default function ClientPage({ title, subtitle, children, actions }) {
  return <div className="horizon-home horizon-client"><div className="horizon-home-inner">
    {title && <header className="horizon-header"><div className="horizon-header-row">
      <div><p className="horizon-breadcrumb">Votre espace</p><h1>{title}</h1>{subtitle && <p className="horizon-subtitle">{subtitle}</p>}</div>
      <div className="horizon-header-actions">{actions}<ThemeToggle /></div>
    </div></header>}
    <div className="client-content">{children}</div>
  </div></div>;
}
